import React, { useState } from 'react';
import {
  Button,
  Text,
  TextInput,
  Modal,
  Flex,
  Loader,
} from '../../components/common';
import styles from './styles.scss';

export default function SignupModal({ isVisible, onClose, signup }) {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    emailAddress: '',
    phone: '',
    password: '',
    confirmPassword: '',
    acceptedTerms: false,
  });
  const updateForm = (key) => (value) => {
    if (key === 'password' && value.target.value.length < 8) {
      setError('Password must be at least 8 characters long.');
    } else if (key === 'confirmPassword' && form.password !== value.target.value) {
      setError('Password & Confirm Password do not match.');
    } else {
      setError('');
    }

    setForm({
      ...form,
      [key]: value && value.target ? value.target.value : value,
    });
  };

  const submitForm = () => {
    setLoading(true);
    signup(form).catch(() => {
      setError('uh oh');
      setLoading(false);
    });
  };

  const isValid =
    form.firstName &&
    form.lastName &&
    form.emailAddress &&
    form.phone &&
    form.password &&
    form.confirmPassword &&
    form.password === form.confirmPassword &&
    form.password.length > 7;

  return (
    <Modal medium isVisible={isVisible} onClose={onClose}>
      <Flex
        flex={1}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Text bold mb={30} thin size={24}>
          Create Account
        </Text>
        <TextInput
          value={form.firstName}
          onChange={updateForm('firstName')}
          placeholder="First Name"
          className={styles.signupInput}
        />
        <TextInput
          value={form.lastName}
          onChange={updateForm('lastName')}
          placeholder="Last Name"
          className={styles.signupInput}
        />
        <TextInput
          value={form.emailAddress}
          onChange={updateForm('emailAddress')}
          placeholder="Email Address"
          className={styles.signupInput}
        />
        <TextInput
          value={form.phone}
          onChange={updateForm('phone')}
          placeholder="Mobile Phone Number"
          className={styles.signupInput}
        />
        <TextInput
          type="password"
          value={form.password}
          onChange={updateForm('password')}
          placeholder="Password"
          className={styles.signupInput}
        />
        <TextInput
          type="password"
          value={form.confirmPassword}
          onChange={updateForm('confirmPassword')}
          placeholder="Confirm Password"
          className={styles.signupInput}
        />
        {error && (
          <Text isError size={14} mt={10} mb={10}>
            {error}
          </Text>
        )}
      </Flex>
      <Flex justifyContent="center" alignItems="center">
        <Button secondary onClick={onClose}>
          Cancel
        </Button>
        {!loading && (
          <Button submit disabled={!isValid} onClick={submitForm}>
            Signup
          </Button>
        )}
        {loading && <Loader size={18} />}
      </Flex>
    </Modal>
  );
}
